import React from 'react';

export const useAntModalOkButton = () => {

    const okButtonRef = React.useRef<HTMLButtonElement | null>(null);

    React.useEffect(() => {
        setTimeout(() => {
            okButtonRef.current = document?.getElementsByClassName(
                'ant-modal-confirm-btns',
            )[0]?.children[0] as HTMLButtonElement;
        }, 500);
    }, []);

    return okButtonRef;
};
